// Maps an extension panel's panel id (ActivityBar.js's targetTabFor sets
// `activeTab` to the panel id for extension items, not the activityBarId) to
// the tab type its content area/tab strip is forced into. Adding another
// extension panel with its own tab strip is just another entry here.
export const EXTENSION_PANEL_TAB_TYPES = {
  'db-manager.panel': 'db-manager-table',
  'task-manager.panel': 'task-manager-board',
  'projects.panel': 'projects-project',
  'documents.panel': 'document-editor',
};

export const EXTENSION_TAB_TYPES = new Set(Object.values(EXTENSION_PANEL_TAB_TYPES));

export const CLOSE_ALL_SCOPE_BY_TAB_TYPE = {
  'db-manager-table': 'db-manager',
  'task-manager-board': 'task-manager', 'projects-project': 'projects',
  'document-editor': 'documents',
};
